// QueryEditorPage.js
import {
   Button,
   Flex,
   Modal,
   ModalBody,
   ModalCloseButton,
   ModalContent,
   ModalFooter,
   ModalHeader,
   ModalOverlay,
   Textarea,
} from '@chakra-ui/react';
import React, { useEffect, useRef, useState } from 'react';

const QueryEditorPage = ({ isOpen, onClose, initialQuery, onSave, setQueryText }) => {
   const loadInitialQuery = `WITH invoice_data AS (
    SELECT 
        s.id as sales_id,
        s."companyId" as sales_company_id,
        s.docno as invoice_no,
        s."transactionAt" as invoice_date,
        s."accountId" as customer_id,
        s."accountId" as delivery_customer_id,
        s."lrNo" as lr_no,
        s."lrDate" as lr_date,
        s."transportId" as transport,
        s."vehicleId" as vehicle_no,
        s."ewayBillno" as eway_bill_no,
        s."ewayBillDate" as eway_bill_date,
        s."einvoiceackno" as ack_no,
        s."einvoiceirn" as irn,
        s."billtoStateId" as place_of_supply,
        s."shiptoStateId",
        s."basicAmount",
        s."taxableAmount",
        s."netAmount"
    FROM sales s
    WHERE s.id IN (<sid>)
),
company_info AS (
    SELECT 
        c.id,
        name as company_name,
        ca.address1 as company_address,
        ca.address2 as company_address2,
        ca.mobile as company_mobile,
        ca."email" as company_email,
        c."gstRegNo" as company_gstin,
        c."panNo" as company_pan,
        c."bankName1" as bank_name,
        c."bankIFSC1" as bank_ifsc,
        c."bankAccno1" as bank_account_no
    FROM company c 
    LEFT JOIN "companyAddress" ca on c.id = ca."companyId"
),
bill_customer AS (
    SELECT 
        a.id,
        a.name as customer_name,
        aa.address1 as customer_address,
        aa.address2 as customer_address2,
        aa."cityId" as customer_city,
        aa."coId" as customer_country,
        a."panNo" as customer_pan,
        a."gstRegNo" as customer_gstin
    FROM account a
    LEFT JOIN "accountAddress" aa on a.id = aa."accId" and aa.name = 'billing'
    WHERE a.id = (SELECT customer_id FROM invoice_data)
),
delivery_customer AS (
    SELECT 
        a.id,
        a.name as delivery_name,
        aa.address1 as delivery_address,
        aa."cityId" as delivery_city,
        aa."coId" as delivery_country,
        a."panNo" as delivery_pan,
        a."gstRegNo" as delivery_gstin
    FROM account a
    LEFT JOIN "accountAddress" aa on a.id = aa."accId" and aa.name = 'shipping'
    WHERE a.id = (SELECT delivery_customer_id FROM invoice_data)
)

SELECT 
    -- Company Information
    ci.company_name as companyname,
    ci.company_address as CompanyAddress,
    ci.company_address2 as CompanyAddress2,
    '{Mo.): ' || ci.company_mobile || ',  Email: ' || ci.company_email as CompanyMobile1Value,
    ci.company_email as CompanyEmailValue,
    COALESCE('GSTIN: ' || ci.company_gstin || ' PAN: ' || ci.company_pan, 'PAN: ' || ci.company_pan) as CompanyGstinValue,
    ci.company_pan as CompanyPanNoValue,
    
    -- Invoice Information
    id.place_of_supply as PlaceofSupplyValue,
    id.invoice_no as InvoiceNoValue,
    TO_CHAR(id.invoice_date, 'dd/MM/yyyy') as InvoiceDtValue,
    id.invoice_no as ChallanNoValue,
	TO_CHAR(id.invoice_date, 'dd/MM/yyyy') as ChallanDtValue,
    id.lr_no as LRnoValue,
    id.lr_date as LRDtValue,
    id.transport as TransportValue,
    id.vehicle_no as VechileNoValue,
    id.eway_bill_no as EwayBillnoValue,
    id.eway_bill_date as EwaybillDtValue,
    id.ack_no as AcknoValue,
    id.irn as IrnValue,
    
    -- Bill Customer Information
    bc.customer_name as BillCustomerName,
    bc.customer_address as BillCustomerAddress1,
    bc.customer_address2 as BillCustomerAddress2,
    bc.customer_city as CustomerCity,
    bc.customer_country as BillCustomerCountry,
    bc.customer_pan as CustomerPanNoValue,
    'GSTIN: ' || bc.customer_gstin as BillCustomerGstinValue,
    
    -- Delivery Customer Information
    dc.delivery_name as DeliverCustomerName,
    dc.delivery_address as DeliveryAddress,
    dc.delivery_city as DeliveryCity,
    dc.delivery_country as DeliveryCountry,
    dc.delivery_pan as DeliveryPanNoValue,
    
    -- Bank Information
    ci.bank_name as BankNameValue,
    ci.bank_account_no as BankAccountNoValue,
    ci.bank_ifsc as BankIfscValue,
    
    -- Item Details
    ROW_NUMBER() OVER (ORDER BY sli.id) as SrNo,
    i.name as ItemName,
    sli.qty1 as Qty1,
    sli.qty2 as Qty2,
    sli.qty3 as Qty3,
    sli."uomNoForRate" as Unit,
    sli."itemRate" as Rate,
    sli."netAmount" as ItemNetAmount,
    sli."gstPercent" as GstPercentage,
    
    -- GST Breakdown
    CASE 
        WHEN sli.sgst > 0 THEN sli."gstPercent"/2 
        ELSE 0 
    END as SGSTPercentage,
    CASE 
        WHEN sli.cgst > 0 THEN sli."gstPercent"/2 
        ELSE 0 
    END as CGSTPercentage,
    CASE 
        WHEN sli.igst > 0 THEN sli."gstPercent" 
        ELSE 0 
    END as IGSTPercentage,
    
    sli.sgst as SGSTValue,
    sli.cgst as CGSTValue,
    sli.igst as IGSTValue,
    
    -- Totals
    id."basicAmount" as BillSubTotal,
    id."taxableAmount" as TotalTaxableValue,
    id."netAmount" as BillNetAmountValue

FROM invoice_data id
INNER JOIN company_info ci on id.sales_company_id = ci.id
LEFT JOIN bill_customer bc ON true
LEFT JOIN delivery_customer dc ON true
LEFT JOIN "salesLineItem" sli ON sli."headerId" = id.sales_id
LEFT JOIN "salesLineDetail" sld ON sld."lineItemId" = sli.id
LEFT JOIN item i ON i.id = sli."itemId"
ORDER BY sli.id`;
   let queryText = initialQuery ? initialQuery : loadInitialQuery;
   const [saving, setSaving] = useState(false);
   const textareaRef = useRef(null);
   useEffect(() => {
      if (isOpen) {
         // Small delay to ensure modal is fully rendered
         const timeoutId = setTimeout(() => {
            if (textareaRef.current) {
               textareaRef.current.focus();
               // Also move cursor to end of text if there's existing content
               textareaRef.current.setSelectionRange(
                  textareaRef.current.value.length,
                  textareaRef.current.value.length,
               );
            }
         }, 150);

         return () => clearTimeout(timeoutId);
      }
   }, [isOpen]);
   const handleSave = async () => {
      setSaving(true);
      try {
         // Simulate API delay
         await new Promise((resolve) => setTimeout(resolve, 500));
         setQueryText(queryText);
         onSave?.(queryText); // send back to parent
      } catch (err) {
         alert('Failed to save query');
      } finally {
         setSaving(false);
      }
   };

   return (
      <Modal isOpen={isOpen} onClose={onClose} size="6xl">
         <ModalOverlay />
         <ModalContent>
            <ModalHeader>Edit SQL Query</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
               <Textarea
                  ref={textareaRef}
                  value={queryText}
                  onChange={(e) => setQueryText(e.target.value)}
                  height="400px"
                  fontFamily="monospace"
                  fontSize="sm"
                  placeholder="SELECT * FROM ..."
                  resize="vertical"
               />
            </ModalBody>
            <ModalFooter>
               <Flex w="100%" justify="space-between">
                  <Flex gap={3}>
                     <Button onClick={onClose} variant="ghost" size="sm">
                        Cancel
                     </Button>
                     <Button onClick={handleSave} isLoading={saving} colorScheme="blue" size="sm">
                        Save
                     </Button>
                  </Flex>
               </Flex>
            </ModalFooter>
         </ModalContent>
      </Modal>
   );
};

export default QueryEditorPage;
